import { FETCH_DCM_PLACEMENTS } from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";

const initialState = { isLoading: false, data: [] };

export const dcmPlacements = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DCM_PLACEMENTS:
      switch (action.status) {
        case SUCCESS:
          return { isLoading: false, data: [...action.data] };
        case FAILURE:
          return { isLoading: false, data: [...state.data] };
        case PENDING:
          return { isLoading: true, data: [...state.data] };
        default:
          return state;
      }
    default:
      return state;
  }
};
